<template>
  <section>
    <div class="productKind">
      <!-- <ProductContent :title="producTitle" :content="productContent" id="Product" /> -->
      <div class="item">
        <div class="circleImg">
          <img src="@/assets/images/lsCard.png" alt />
        </div>
        <div class="contentBox">
          <p class="title">鲁商卡</p>
          <p
            class="content"
            :style="{color:'#8F8F8F'}"
          >“鲁商卡”是在山东省商务厅监管下合法合规发行的单用途预付卡虚拟卡，牌照号370000BAA0001。</p>
        </div>
      </div>
      <div class="item">
        <div class="circleImg">
          <img src="@/assets/images/beans.png" alt />
        </div>
        <div class="contentBox">
          <p class="title">豆芽团</p>
          <p class="content" :style="{color:'#8F8F8F'}">为会员专门开辟会员银豆积分兑换。每周二更新不同的产品，会员可以用银豆兑换商品及服务。</p>
        </div>
      </div>
      <div class="item">
        <div class="circleImg">
          <img src="@/assets/images/rich.png" alt />
        </div>
        <div class="contentBox">
          <p class="title">睿持团</p>
          <p class="content" :style="{color:'#8F8F8F'}">鲁商通为企业客户定制的专属折扣权益产品，可根据企业要求定制不同的产品权益及服务。</p>
        </div>
      </div>
      <div class="item">
        <div class="circleImg">
          <img src="@/assets/images/bank.png" alt />
        </div>
        <div class="contentBox">
          <p class="title">银行精选</p>
          <p class="content" :style="{color:'#8F8F8F'}">鲁商通跟商业银行合作，推出的线上信用贷款服务。</p>
        </div>
      </div>
      <div class="item">
        <div class="circleImg">
          <img src="@/assets/images/shouyi.png" alt />
        </div>
        <div class="contentBox">
          <p class="title">收益权转让产品</p>
          <p class="content" :style="{color:'#8F8F8F'}">面向特定对象的收益权转让产品</p>
        </div>
      </div>
      <div class="item">
        <!-- <div class="circleImg">
          <img src="@/assets/images/shouyi.png" alt />
        </div>
        <p>收益权转让产品</p>
        <p
          :style="{fontSize:'14px',color:'#8F8F8F'}"
        >面向特定对象的收益权转让产品</p>-->
      </div>
    </div>
  </section>
</template>
<script>
// import ProductContent from "@/components/ProductContent";
export default {
  // components: {
  //   ProductContent,
  // },
  data() {
    return {
      // producTitle: "鲁商通产品",
      // productContent: "鲁商通依托于鲁商生态，为您提供多元的数字科技产品",
    };
  },
};
</script>
<style scoped lang="scss">
.productKind {
  text-align: center;
  color: #000000;
  width: 1200px;
  display: flex;
  margin: 0 auto;
  flex-wrap: wrap;
  justify-content: space-between;
}
.item {
  text-align: center;
  width: 280px;
  margin-left: 40px;
  margin-right: 40px;
  // margin-top: 30px;
  .circleImg {
    width: 180px;
    height: 180px;
    background: #fff4e7;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 50px;
    img {
      height: 36%;
    }
  }
}
.title {
  // padding: 27px 0;
  padding-top: 31px;
  padding-bottom: 18px;
  font-size: 22px;
}
.content {
  padding-bottom: 90px;
  font-size: 15.5px;
  line-height: 28px;
  text-align-last: center;
  text-align: justify;
  letter-spacing: 0.5px;
}
@media (max-width: 767.98px) {
  .productKind {
    width: 90%;
    margin-left: 5%;
    margin-right: 5%;
    .item {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
      margin-bottom: 40px;
      display: flex;
      .circleImg {
        width: 90px;
        height: 90px;
        margin-left: 0;
        margin-top: 10px;
      }
      .contentBox {
        margin-left: 10px;
        width: 73%;
        p {
          margin: 10px;
          padding: 0;
        }
      }
    }
  }
  .title {
    font-size: 16px;
    text-align: left;
  }
  .content {
    font-size: 13px;
    text-align: left;
    text-align-last: left;
  }
  .content {
    line-height: 23px;
  }
}
</style>